import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

// The section pattern used across the app (ServiceDetailView, SupaBuildingAddress,
// AccountDetailPage, the outage dialogs): a bordered card with a navy title band that
// bleeds to the card's edges.
export const SectionLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ bgcolor: '#1e3a5c', px: 2.5, py: 0.75, mx: -2.5, mt: -2.5, mb: 2.5, borderRadius: '4px 4px 0 0' }}>
    <Typography variant="caption" sx={{ fontWeight: 700, letterSpacing: 0.8, textTransform: 'uppercase', color: '#ffffff' }}>
      {children}
    </Typography>
  </Box>
);

const FormSection: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <Paper variant="outlined" sx={{ p: 2.5 }}>
    <SectionLabel>{title}</SectionLabel>
    {children}
  </Paper>
);

export default FormSection;
